import React from "react";
import { Link, LinkProps } from "react-router-dom";
import LightTheme from "../theme/LightTheme";

interface Props {
  text: string;
  children: React.ReactNode;
  linkTo: LinkProps["to"] | string;
}

const SidebarIcon = ({ text, children, linkTo }: Props) => (
  <div className="navWrapper">
    {typeof linkTo === "string" ? (
      <a href={linkTo}>
        <div className="buttonWrapper">
          {children}
          <span>{text}</span>
        </div>
      </a>
    ) : (
      <Link to={linkTo}>
        <div className="buttonWrapper">
          {children}
          <span>{text}</span>
        </div>
      </Link>
    )}

    <style jsx>{`
      .navWrapper {
        min-width: 60px;
        max-width: 100px;
        height: 100px;
        width: 7vw;
      }
      .navWrapper :global(a) {
        text-decoration: none;
      }
      .navWrapper :global(a:hover) div {
        background: #e5e5e5;
      }
      span {
        font-size: 0.8rem;
        color: #4a4a4b;
        font-weight: bold;
      }
      div {
        color: #4a4a4b;
      }
      .buttonWrapper {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        flex: 1 1 auto;
        height: 100%;
      }

      .colorLine {
        height: 80px;
        width: 4px;
        background: ${LightTheme.gradientBackground};
      }
    `}</style>
  </div>
);

export default SidebarIcon;
